import { DayIndex } from "@domain/program/program-days";
import { Exertion, Mood } from "@domain/progress/patient-feedback";
import { addDaysToDate, now } from "@utils/date-utils";
import { Dayjs } from "dayjs";

export interface ProgressData {
	programProgressInPercent: number;
	programComplianceInPercent: number;
	sessionsPerWeek: number;
	exercisesPerWeek: number;
	startDate: Dayjs;
	endDate: Dayjs;
	lastCompletedSession?: Dayjs;
	completedSessionsCount: number;
	pastSessionsCount: number;
	totalSessions: number;
}

interface CompliancePerWeek {
	weekIndex: number;
	startDate: Dayjs;
	endDate: Dayjs;
	compliancePercentage: number;
	days: ComplianceDay[];
}

export interface ComplianceDay {
	day: DayIndex;
	completed: boolean;
}

export type ComplianceGraphData = CompliancePerWeek[];

interface FeedbackPerSession {
	completionDate: Dayjs;
	index: number;
	exertion: Exertion | null;
	mood: Mood | null;
}

export interface FeedbackGraphData {
	feedbacks: FeedbackPerSession[];
}

export function getFakeProgressData(
	programProgressInPercent?: number,
	programComplianceInPercent?: number,
): ProgressData {
	return {
		programProgressInPercent: programProgressInPercent ?? 0,
		programComplianceInPercent: programComplianceInPercent ?? 80,
		sessionsPerWeek: 4,
		exercisesPerWeek: 10,
		startDate: now(),
		endDate: now(),
		lastCompletedSession: now(),
		completedSessionsCount: 16,
		pastSessionsCount: 20,
		totalSessions: 40,
	};
}

export function getFakeComplianceGraphData(): CompliancePerWeek[] {
	const currentDate = now();
	const compliancePercentages = [100, 75, 75, 0, 50, 25, 75, 75];
	return generateComplianceGraphData(currentDate, compliancePercentages);
}

export function generateComplianceGraphData(date: Dayjs, compliancePercentages: number[]): CompliancePerWeek[] {
	return compliancePercentages.map((percentage, i) => ({
		weekIndex: i,
		compliancePercentage: percentage,
		startDate: now(),
		endDate: now(),
		days: [],
	}));
}

export function getFakeFeedbackGraphData(): FeedbackGraphData {
	const currentDate = now();
	return {
		feedbacks: [
			{ completionDate: addDaysToDate(currentDate, -14), index: 1, exertion: 6, mood: 1 },
			{ completionDate: addDaysToDate(currentDate, -13), index: 2, exertion: 2, mood: 6 },
			{ completionDate: addDaysToDate(currentDate, -12), index: 3, exertion: 1, mood: 5 },
			{ completionDate: addDaysToDate(currentDate, -11), index: 4, exertion: 2, mood: 2 },
			{ completionDate: addDaysToDate(currentDate, -10), index: 5, exertion: 5, mood: 6 },
			{ completionDate: addDaysToDate(currentDate, -9), index: 6, exertion: 4, mood: 5 },
			{ completionDate: addDaysToDate(currentDate, -8), index: 7, exertion: 3, mood: 1 },
			{ completionDate: addDaysToDate(currentDate, -7), index: 8, exertion: 5, mood: 2 },
			{ completionDate: addDaysToDate(currentDate, -6), index: 9, exertion: 2, mood: 6 },
			{ completionDate: addDaysToDate(currentDate, -5), index: 10, exertion: 4, mood: 3 },
			{ completionDate: addDaysToDate(currentDate, -4), index: 11, exertion: 5, mood: 2 },
			{ completionDate: addDaysToDate(currentDate, -3), index: 12, exertion: 5, mood: 1 },
			{ completionDate: addDaysToDate(currentDate, -2), index: 13, exertion: 6, mood: 2 },
			{ completionDate: addDaysToDate(currentDate, -1), index: 14, exertion: 3, mood: 6 },
			{ completionDate: currentDate, index: 15, exertion: 1, mood: 1 },
		],
	};
}
